{
  "deselectedItem": "{item} no seleccionado.",
  "select": "Seleccionar",
  "selectedAll": "Todos los elementos seleccionados.",
  "selectedCount": "{count, plural, =0 {Ningún elemento seleccionado} one {# elemento seleccionado} other {# elementos seleccionados}}.",
  "selectedItem": "{item} seleccionado."
}
